import { render, staticRenderFns } from "./GeekTimeCourseItem.vue?vue&type=template&id=51c1c906&scoped=true"
import script from "./GeekTimeCourseItem.vue?vue&type=script&lang=js"
export * from "./GeekTimeCourseItem.vue?vue&type=script&lang=js"
import style0 from "./GeekTimeCourseItem.vue?vue&type=style&index=0&id=51c1c906&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c1c906",
  null
  
)

export default component.exports